import React, { useEffect, useState } from "react";
import {
  Container,
  Stack,
  Typography,
  Button,
  useTheme,
  Box,
  useMediaQuery,
} from "@mui/material";
import { motion } from "framer-motion";
import { GradientBorderBox } from "../../../../Components";
import PopularProductsCard from "./PopularProductsCard";
import { useGetProductsQuery } from "../../../../Store/Slices/rtk";
import { useNavigate } from "react-router-dom";
import NorthWestIcon from "@mui/icons-material/NorthWest";

export default function PopularProducts({ products = [] }) {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:900px)");
  const [dir, setDir] = useState("row");
  const [centerIndex, setCenterIndex] = useState(1);

  // کامنت انگلیسی خدایی قفل میکردی
  // فقط محتوای کارت‌ها fade می‌شود
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const timer = setInterval(() => {
      // مرحله ۱ → جهت فلکس برعکس شود
      setDir((prev) => (prev === "row" ? "row-reverse" : "row"));

      // مرحله ۲ همزمان با تغییر دایرکشن، محتوا fade-out شود
      setFade(false);

      // مرحله ۳ بعد از fade-out، محتوا عوض شود
      setTimeout(() => {
        setCenterIndex((prev) => (prev + 1) % products.length);

        // مرحله ۴ بعد از تغییر محتوا fade-in شود
        setFade(true);
      }, 400); // زمان خروج محتوا
    }, 3500);

    return () => clearInterval(timer);
  }, []);

  // محاسبه ۳ آیتم اطراف مرکز
  const visible = [
    products[(centerIndex - 1 + products.length) % products.length],
    products[centerIndex],
    products[(centerIndex + 1) % products.length],
  ];

  const items = visible?.map((pr, i) => (
    <motion.div
      key={i}
      layout
      transition={{ duration: 2 }}
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
      }}
    >
      <PopularProductsCard pr={pr} index={i} selectedIndex={1} fade={fade} />
    </motion.div>
  ));

  return (
    <>
      <Container maxWidth={"exl"} sx={{ position: "relative" }}>
        <Stack
          direction={"row-reverse"}
          sx={{
            alignItems: "center",
            position: "relative",
            p: "1rem",
            mt: { xs: "15rem", lg: "15rem" },
            minHeight: "150px",
          }}
        >
          {/* content */}
          <Stack
            direction={{ xs: "row", lg: "column" }}
            sx={{
              textAlign: "center",
              position: { xs: "absolute", lg: "static" },
              bottom: "100%",
              left: "50%",
              transform: {
                xs: "translate(-50% , -320%)",
                lg: "translate(0% , 0%)",
              },
              width: { xs: "100%", lg: "auto" },
              justifyContent: { xs: "space-between", lg: "start" },
            }}
          >
            <Stack
              sx={{
                width: { xs: "50%", lg: "100%" },
                alignItems: "center",
                transform: { xs: "translateX(-50%)", lg: "translateX(0%)" },
              }}
            >
              <Typography sx={{ fontSize: "1.5rem", fontWeight: "bold" }}>
                محبوبترین
              </Typography>
              <Typography
                sx={{
                  color: theme.palette.primary.main,
                  display: "block",
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                }}
              >
                محصولات
              </Typography>
            </Stack>
            <Button
              onClick={() => navigate("products/@popular")}
              sx={{
                fontSize: "inherit",
                fontWeight: "bold",
                borderRadius: "10px",
                color: "white",
                bgcolor: "transparent",
                position: "relative",
                height: "50px",
                width: { xs: "50px", lg: "auto" },
                zIndex: "20",
                mt: ".5rem",
                minWidth: "0",
                ":hover": {
                  bgcolor: "rgba(59, 59, 59, 0.2)",
                },
              }}
            >
              {isMobile ? <NorthWestIcon /> : " مشاهده همه"}
              <GradientBorderBox
                inside={true}
                radius={isMobile ? "50%" : "10px"}
              />
            </Button>
          </Stack>

          {/* cards */}
          {products?.length <= 2 ? (
            <Stack
              sx={{
                justifyContent: "center",
                alignItems: "center",
                width: "80%",
                mx: "auto",
              }}
            >
              <Typography>تعداد محصولات کافی نمیباشد !</Typography>
            </Stack>
          ) : (
            <Stack
              sx={{
                position: "absolute",
                right: { xs: "50%", lg: "2rem" },
                bottom: "1rem",
                width: { xs: "max-content", lg: "80%" },
                transform: { xs: "translateX(50%)", lg: "translateX(0)" },
              }}
            >
              <Stack
                direction={dir}
                sx={{
                  width: "100%",
                  gap: "1rem",
                  justifyContent: "space-between",
                }}
              >
                {items}
              </Stack>
            </Stack>
          )}

          {isMobile ? null : <GradientBorderBox />}
        </Stack>
      </Container>
    </>
  );
}
